/**
 * Csv Schema of FormatoArquivoRelatorio
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'

/* TODO: review generated schema */
export class CsvFormatoArquivoRelatorioSchema extends Schema {
  readonly name = 'CsvFormatoArquivoRelatorio'

  readonly fieldSet: FieldSet<FormatoArquivoRelatorio> = {
    idFormatoArquivoRelatorioPk: schema =>
      schema.model.idFormatoArquivoRelatorioPk,
    descricao: schema => schema.model.descricao,
  }
}
